// extracted by mini-css-extract-plugin
export default {"AboutMe":"AboutMe_AboutMe__KYzi6"};